import React, {useState} from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
    Box,
    Stack,
    Card,
    CardContent,
    Chip,
    Divider,
    useTheme,
    useMediaQuery,
    Grid
} from "@mui/material";
import formatNumber from "../../../../../helpers/formatNumber";
import {AccountBalance, History, Event, TrendingUp, TrendingDown} from '@mui/icons-material';

interface CariTablosuProps {
    cariler: any[];
}

const CariTablosu = ({cariler}: CariTablosuProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const paginatedCariler = (cariler || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Box sx={{ width: '100%' }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2.5, px: 1 }}>
                <History color="primary" />
                <Typography variant="h6" fontWeight={800} sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
                    Cari Hareketler
                </Typography>
            </Stack>

            {isMobile ? (
                <Stack spacing={2}>
                    {paginatedCariler.map((row: any, index: number) => (
                        <Card key={"cariler-m-" + index} sx={{ borderRadius: '16px', border: '1px solid rgba(0,0,0,0.05)' }}>
                            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Event fontSize="inherit" sx={{ opacity: 0.6 }} />
                                        <Typography variant="body2" fontWeight={700}>{row.tarih}</Typography>
                                    </Stack>
                                    <Chip 
                                        label={row.tip} 
                                        size="small" 
                                        color={row.tip === 'Ödeme' ? 'success' : 'primary'}
                                        variant="outlined"
                                        sx={{ fontWeight: 800, borderRadius: '6px' }}
                                    />
                                </Box>
                                <Divider sx={{ my: 1.5, opacity: 0.5 }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography variant="caption" color="textSecondary" display="block">MİKTAR</Typography>
                                        <Typography variant="subtitle1" fontWeight={800} color={row.miktar >= 0 ? 'success.main' : 'error.main'}>
                                            {formatNumber(row.miktar)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="caption" color="textSecondary" display="block">BAKİYE</Typography>
                                        <Typography variant="subtitle1" fontWeight={800}>
                                            {formatNumber(row.sonBakiye)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    ))}
                </Stack>
            ) : (
                <TableContainer component={Paper} sx={{ borderRadius: '16px', border: '1px solid rgba(0,0,0,0.05)', boxShadow: 'none' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: 'grey.50' }}>
                                <TableCell sx={{ fontWeight: 800 }}>Tarih</TableCell>
                                <TableCell sx={{ fontWeight: 800 }}>Hareket Tipi</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 800 }}>Miktar</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 800 }}>Son Bakiye</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedCariler.map((row: any, index: number) => (
                                <TableRow key={"cariler-" + index} sx={{ '&:hover': { bgcolor: 'rgba(0,0,0,0.01)' } }}>
                                    <TableCell sx={{ fontWeight: 600 }}>{row.tarih}</TableCell>
                                    <TableCell>
                                        <Chip 
                                            label={row.tip} 
                                            size="small" 
                                            color={row.tip === 'Ödeme' ? 'success' : 'primary'}
                                            sx={{ fontWeight: 700, borderRadius: '4px' }}
                                        />
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 800, color: row.miktar >= 0 ? 'success.main' : 'error.main' }}>
                                        {formatNumber(row.miktar)}
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 800 }}>
                                        {formatNumber(row.sonBakiye)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={cariler?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ mt: 1 }}
            />
        </Box>
    );
};

export default CariTablosu;
